import React, {useState, useEffect , useRef} from "react";
import { Link } from "react-router-dom";

import LeftMenuLayout from 'layouts/LeftMenuLayout';

import classNames from 'classnames';
import * as Yup from 'yup';
import {API_ENDPOINT, toast_anim , toast_anim_error} from 'components/config/Common'
import {Loading} from "components/custom-icons";

import axios from 'axios';  
import {APP_URL, APP_NAME , IMG_URL ,amount_format , dnyreasonOptions } from 'components/config/Common'

import Helmet from 'react-helmet'
import { ReactSEOMetaTags } from 'react-seo-meta-tags'
import { toast } from 'react-toastify';
import ScrollPageTop from 'components/ui/ScrollPageTop'
import SelectInput from 'components/ui/select-input.jsx'
import { yupResolver } from '@hookform/resolvers/yup';
import Input from 'components/ui/input.jsx'
import Label from 'components/ui/label.tsx'
import Button from 'components/ui/Button.tsx'
import TextArea from 'components/ui/text-area';
import {
	Control,
	FieldErrors,
	useForm,
	useFormState,
	useWatch,
	Controller
 } from 'react-hook-form';

const amountSchema = Yup.object().shape({
	reason: Yup.object().nullable()
      .required('Reason is required'),
});


let defaultValues = {  
	reason: {
		id:'',
		label:'',
	},
};

const DenyAppointmentRequest = (props) => {
	
	const [access_token, setAccess_token] = useState(localStorage.getItem('access_token'))
	const [user_type, setUser_type] = useState(localStorage.getItem('user_type'))
	const [apprequ,setApprequ] = useState(props.apprequ);
	const [user_me, setUser_me] = useState(null);
	const [loading, setLoading] = useState(false);
	const [loading_social, setLoading_social] = useState(false);
   const [enabled, setEnabled] = useState(false)
  	const [totalamount,setTotalamount] = useState(0);
  	const [bankdtlist,setBankdtlist]= useState(null);
  	const [selectedreason,setSelectedreason]= useState();

  	//const [reason,setReason] = useState('');
	const { register, handleSubmit , control, reset, setValue, setError, formState: { errors },} = useForm({
		defaultValues: defaultValues,
		resolver: yupResolver(amountSchema),
		
  	});


	useEffect(() => {
		
			//getBankAccountList();
	},[])
	

	

	
	const onSubmit = (values) => {
		console.log('value', values);
		setLoading(true);		

		//let input = values;
     
      setLoading(true);
        let input = apprequ;
      input = {appointment:apprequ?.appoint_id,status:'denied',
         user_email:apprequ?.user?.email,user_id:apprequ?.user?.id,user_name:apprequ?.user?.user_name,reason:values?.reason?.label,other_reason:values?.other_reason};
      axios.post(`${API_ENDPOINT}/update_appoint_status`,input,{
         headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer '+access_token,
         }
      }).then( (result)=> {
         console.log('data=====',result.data)
         setLoading(false)
         console.log('data=====',result)
			if(result.data.status == 1){
				toast_anim(result.data.message);
				props.closeDenyappoint();
			}else if(result.data.status == 0){
				toast_anim_error(result.data.message);
			}
      })
		
	}

	const handleSelect = (val,name) => {  
      console.log('cat val======',val,name.name)
      setError(name.name, null)
      //setReason(val?.label);
      setValue(name.name, val, true);
      setSelectedreason(val?.label);
   }

	return (<div className="w-full">
					<div className={classNames('w-full p-5 md:p-8 bg-light dark:bg-gray-700 shadow rounded mb-8')}>
						<p className="text-lg lg:text-xl text-heading capitalize mb-2 dark:text-zinc-400">Deny Appointment Request </p>
						
						<form onSubmit={handleSubmit(onSubmit)}>
								<div className="flex w-full flex-col">
									  <div className="mb-5">
			                     <Label>Language <span className="text-red-500"> </span></Label>
			                           <SelectInput
			                              name="reason"                            
			                              control={control}
			                              getOptionLabel={(option: any) => option.label}
			                              getOptionValue={(option: any) => option.label}                        
			                              options={dnyreasonOptions}
			                              onChange={handleSelect}   
			                          
			                           />
			                     <p className="my-2 text-xs text-start text-red-500">{errors?.reason?.message}</p>
			                   </div>
			                   {selectedreason && selectedreason == "Reason Not in the list"?
				                   <div className="mb-5 w-1/2">
			                      <TextArea
				                   name="other_reason"
				                   placeholder="Tell your reason to deny"
				                   {...register('other_reason')}
				                    />
				                  </div>
				                 :
				                 null
				                }
	                      </div>
								<div className="flex">
									<div className="flex  align-center justify-center">
									{
									!loading
									?	
									<button data-variant="normal" className="inline-flex items-center justify-center shrink-0 font-semibold leading-none rounded outline-none transition duration-300 ease-in-out focus:outline-none focus:shadow focus:ring-1 focus:ring-accent-700 bg-accent text-light border border-transparent hover:bg-accent-hover px-5 py-0 h-12 ltr:ml-auto rtl:mr-auto">Confirm Deny</button>
									:
									<Loading className="w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-assent-600 ltr:ml-auto" />
									}
									<button data-variant="normal" onClick={props.closeDenyappoint} className="ml-2 inline-flex items-center justify-center shrink-0 font-semibold leading-none rounded outline-none transition duration-300 ease-in-out focus:outline-none focus:shadow focus:ring-1 focus:ring-accent-700 bg-black text-light border border-transparent hover:bg-black-hover px-5 py-0 h-12 ltr:ml-2 rtl:mr-auto">Close</button>
									</div>
								</div>
							</form>
					</div>
			</div>
   );
};

export default DenyAppointmentRequest